
const CaretSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Warehouse",
                "tableName": "",
                "label": "Warehouse",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Location",
                "tableName": "",
                "label": "Location",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CrateNumber",
                "tableName": "",
                "label": "Crate Number",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "Description",
                "tableName": "",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }
];
export default CaretSearchFormLayout;